"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const content_1 = require("@prismicio/types-internal/lib/content");
const O = tslib_1.__importStar(require("fp-ts/lib/Option"));
const StaticWidgetRenderer_1 = tslib_1.__importDefault(require("../StaticWidgetRenderer"));
const SimpleSliceRenderer = (ctx) => ({
    renderV1(content, fetch) {
        if (content.__TYPE__ === content_1.EmptyContentType) {
            return O.none;
        }
        return O.some({
            value: (0, StaticWidgetRenderer_1.default)(ctx).renderV1(content, fetch),
        });
    },
    renderV2(def, content, fetch) {
        if (content.__TYPE__ === content_1.EmptyContentType) {
            return O.none;
        }
        return O.some({
            value: (0, StaticWidgetRenderer_1.default)(ctx).renderV2(def.widget, content, fetch),
        });
    },
    renderDefault(_def) {
        return {};
    },
    renderMocks(def, content) {
        if (content.__TYPE__ === content_1.EmptyContentType) {
            return O.none;
        }
        return O.some({
            value: (0, StaticWidgetRenderer_1.default)(ctx).renderMocks(def.widget, content),
        });
    },
});
exports.default = SimpleSliceRenderer;
